import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectAuthAccessToken } from "../../app-main/selectors/auth.selectors";
import {
  selectVatProfiles,
  selectVatProfilesHaveFetched,
} from "../../app-main/selectors/fee-profile.selectors";
import {
  selectFeeRegions,
  selectFeesHaveFetched,
  selectFeeTypes,
} from "../../app-main/selectors/fees.selectors";

import { getTaxRegistrations } from "./TaxDetails.utils";
import { useRegistrationFees } from "./useRegistrationFees";

/**
 * Derives the guest's tax registrations. Saved ones are read against their own
 * countries' fees; with none saved, against the whole of the country the page
 * loaded fees for, so every province's taxes can be offered.
 */
const useTaxRegistrations = () => {
  const accessToken = useSelector(selectAuthAccessToken);
  const vatProfiles = useSelector(selectVatProfiles);
  const storeFeeTypes = useSelector(selectFeeTypes);
  const storeRegions = useSelector(selectFeeRegions);
  const haveVatProfilesFetched = useSelector(selectVatProfilesHaveFetched);
  const haveFeesFetched = useSelector(selectFeesHaveFetched);
  const registrationFees = useRegistrationFees({
    accessToken,
    fallbackCountry: storeRegions[0]?.country,
    vatProfiles,
  });

  const feeTypes = registrationFees.fees?.feeTypes ?? storeFeeTypes;
  const regions = registrationFees.fees?.regions ?? storeRegions;

  const registrations = useMemo(
    () => getTaxRegistrations({ feeTypes, regions, vatProfiles }),
    [feeTypes, regions, vatProfiles],
  );

  return {
    isLoading:
      !haveVatProfilesFetched || !haveFeesFetched || registrationFees.isLoading,
    registrations,
  };
};

export { useTaxRegistrations };
